import React, { useEffect, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import Swal from "sweetalert2";
import request from "../../../../Helpers/API";
import PlantillaScreen from "../../../helpers/PlantillaScreen2";
import { LoaderScreen } from "../../../components/LoaderScreen";
import SaveIcon from "@mui/icons-material/Save";
import CodeIcon from "@mui/icons-material/Code";
import PersonIcon from "@mui/icons-material/Person";

// Modal de Alta/Edición del catálogo Código-Vendedor (Postventa / Reporte
// de Refacciones / Vendedores Equipo). Un solo modal para ambos casos: sin
// `registro` es alta (POST con idlistado -99), con `registro` es edición
// (POST con el idlistado real). Sigue la convención ram-modal del proyecto.
//
// Props:
// - open: boolean.
// - registro: { idlistado, codigo, vendedor } o null/undefined si es alta.
// - onClose: fn().
// - onGuardado: fn() opcional, se llama después de guardar con éxito.
export const VendedoresEquipModal = ({ open, registro, onClose, onGuardado }) => {
    const esEdicion = !!registro;

    const [catalogos, setCatalogos] = useState({ codigo: [], vendedores: [] });
    const [codigo, setCodigo] = useState("");
    const [vendedor, setVendedor] = useState("");
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    // Al abrir: precarga los valores del registro (si es edición) y trae el
    // catálogo de códigos/vendedores para los 2 Autocomplete.
    useEffect(() => {
        if (!open) return;

        setCodigo(registro?.codigo || "");
        setVendedor(registro?.vendedor || "");

        setLoader((prev) => ({ ...prev, mostrar: true }));
        request
            .get("CodigoVendedoresEquip/Codigos")
            .then((result) => {
                console.log(result)
                setCatalogos({
                    codigo: result?.codigo || [],
                    vendedores: result?.vendedores || [],
                });
                setLoader((prev) => ({ ...prev, mostrar: false }));
            })
            .catch(() => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                Swal.fire(
                    "VENDEDORES EQUIPO",
                    "No fue posible cargar los catálogos de código y vendedor. Intente nuevamente o contacte al administrador.",
                    "error"
                );
            });
    }, [open, registro]);

    if (!open) return null;

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) onClose?.();
    };

    const onGuardar = () => {
        if (!codigo) {
            Swal.fire("VENDEDORES EQUIPO", "Seleccione un código.", "warning");
            return;
        }
        if (!vendedor || !vendedor.trim()) {
            Swal.fire("VENDEDORES EQUIPO", "Indique el vendedor.", "warning");
            return;
        }

        const post = {
            idlistado: esEdicion ? registro.idlistado : -99,
            codigo,
            vendedor: vendedor.trim(),
        };

        setLoader((prev) => ({ ...prev, mostrar: true }));
        request
            .post("CodigoVendedoresEquip/Guardar", post)
            .then(async () => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                await Swal.fire("VENDEDORES EQUIPO", "Registro guardado con éxito.", "success");
                onGuardado?.();
                onClose?.();
            })
            .catch(() => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                Swal.fire(
                    "VENDEDORES EQUIPO",
                    "No fue posible guardar el registro. Intente nuevamente o contacte al administrador.",
                    "error"
                );
            });
    };

    return (
        <div className="ram-backdrop" >
            <PlantillaScreen
                titulo={esEdicion ? "Editar código de vendedor" : "Agregar código de vendedor"}
                className={"ram-modal"}
            >
                <button className="ram-close" onClick={onClose} type="button">
                    X
                </button>
                <LoaderScreen loader={loader} />

                <div className="ram-body">
                    {/* Código: selección obligatoria del catálogo (no admite texto libre). */}
                    <div className="ram-field">
                        <div className="ram-field__icon">
                            <CodeIcon />
                        </div>
                        <div className="ram-field__content">
                            <Autocomplete
                                size="small"
                                options={catalogos.codigo}
                                value={codigo || null}
                                onChange={(_, newValue) => setCodigo(newValue || "")}
                                renderInput={(params) => (
                                    <TextField {...params} label="Código" placeholder="Buscar código..." />
                                )}
                            />
                        </div>
                    </div>

                    {/* Vendedor: freeSolo, admite elegir del catálogo o escribir un nombre nuevo. */}
                    <div className="ram-field">
                        <div className="ram-field__icon">
                            <PersonIcon />
                        </div>
                        <div className="ram-field__content">
                            <Autocomplete
                                size="small"
                                freeSolo
                                options={catalogos.vendedores}
                                inputValue={vendedor}
                                onInputChange={(_, newInputValue) => setVendedor(newInputValue)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Vendedor"
                                        placeholder="Buscar o escribir el nombre del vendedor..."
                                    />
                                )}
                            />
                        </div>
                    </div>
                </div>

                <div className="ram-footer">
                    <button
                        type="button"
                        className="ram-btn ram-btn--primary"
                        onClick={onGuardar}
                        disabled={loader.mostrar}
                    >
                        <SaveIcon />
                        Guardar
                    </button>
                </div>
            </PlantillaScreen>
        </div>
    );
};

export default VendedoresEquipModal;
